import Vue from "vue";
import Vuex from "vuex";
import base from "@/store/base";
import confirmationModal from "@/store/confirmationModal";
import uploadModal from "@/store/uploadModal";
import entityModal from "@/store/entityModal";
import drawingDownload from "@/store/drawingDownload";
import api from "@/store/api";
import auth from "@/store/auth";
import dimSearch from "@/store/common/dimSearch"

import userPreferences from "@/store/adm/userPreferences";
import threadHistory from "@/store/adm/threadHistory";
import systemParameters from "@/store/adm/systemParameters";
import integrationMessage from "@/store/adm/integrationMessage";
import integrationMessageConfig from "@/store/adm/integrationMessageConfig";
import userSetting from "@/store/adm/userSetting";
import role from "@/store/adm/role";
import dataField from "@/store/adm/dataField";
import chart from "@/store/adm/chart";

//master
import systemType from "@/store/master/systemType";
import systemInstance from "@/store/master/systemInstance";
import messageType from "@/store/master/messageType";
import teamShift from '@/store/master/teamShift/teamShift';
import location from "@/store/master/location";
import equipment from "@/store/master/equipment";
import report from "@/store/master/report";
import reportGenerated from "@/store/master/reportGenerated";
import material from "@/store/master/material";
import energy from "@/store/master/energy";

import processOption from "@/store/master/processConf/processOption";
import processMaterial from "@/store/master/processConf/processMaterial";
import processEnergy from "@/store/master/processConf/processEnergy";

//inventory
import rawMaterial from "@/store/prd/inventoryMgt/rawMaterial";
import adjust from "@/store/prd/inventoryMgt/adjust";
import outIn from "@/store/prd/inventoryMgt/outIn";
import formulaPlan from "@/store/prd/inventoryMgt/formulaPlan";
import formulaPlanDetails from "@/store/prd/inventoryMgt/formulaPlanDetails";

//prd plan
import downtimePlan from "@/store/prd/productionPlan/downtimePlan";
import monthPlan from "@/store/prd/productionPlan/monthPlan";
import matRequireMonthPlan from "@/store/prd/productionPlan/matRequireMonthPlan";
import shiftPlan from "@/store/prd/productionPlan/shiftPlan";
import qualitySpecification from "@/store/prd/qualityMgt/qualitySpecification";

//prd result
import pelletizingEnergyCost from "@/store/prd/productionExecution/pelletizing/pelletizingEnergyCost";
import pelletizingEquipPara from "@/store/prd/productionExecution/pelletizing/pelletizingEquipPara";
import pelletizingMaterialCost from "@/store/prd/productionExecution/pelletizing/pelletizingMaterialCost";
import pelletizingProductInfo from "@/store/prd/productionExecution/pelletizing/pelletizingProductInfo";
import pelletizingProductionResult from "@/store/prd/productionExecution/pelletizing/pelletizingProductionResult";
import pelletizingProductQuality from "@/store/prd/productionExecution/pelletizing/pelletizingProductQuality";
import pelletizingProductionQuality from "@/store/prd/productionExecution/pelletizing/pelletizingProductionQuality";
import pelletizingProductionQualityItem
    from "@/store/prd/productionExecution/pelletizing/pelletizingProductionQualityItem";

import smeltingEnergyCost from "@/store/prd/productionExecution/smelting/smeltingEnergyCost";
import smeltingEquipPara from "@/store/prd/productionExecution/smelting/smeltingEquipPara";
import smeltingMaterialCost from "@/store/prd/productionExecution/smelting/smeltingMaterialCost";
import smeltingProductInfo from "@/store/prd/productionExecution/smelting/smeltingProductInfo";
import smeltingProductionResult from "@/store/prd/productionExecution/smelting/smeltingProductionResult";
import smeltingProductQuality from "@/store/prd/productionExecution/smelting/smeltingProductQuality";
import smeltingProductionQuality from "@/store/prd/productionExecution/smelting/smeltingProductionQuality";
import smeltingProductionQualityItem from "@/store/prd/productionExecution/smelting/smeltingProductionQualityItem";

//report
import dayEnergyCost from "@/store/prd/productionReport/dayReport/dayEnergyCost";
import dayEquipPara from "@/store/prd/productionReport/dayReport/dayEquipPara";
import dayMaterialCost from "@/store/prd/productionReport/dayReport/dayMaterialCost";
import dayPelletizingProductInfo from "@/store/prd/productionReport/dayReport/dayPelletizingProductInfo";
import dayPelletizingProductQuality from "@/store/prd/productionReport/dayReport/dayPelletizingProductQuality";
import daySmeltingProductInfo from "@/store/prd/productionReport/dayReport/daySmeltingProductInfo";
import daySmeltingProductQuality from "@/store/prd/productionReport/dayReport/daySmeltingProductQuality";
import monthEnergyCost from "@/store/prd/productionReport/monthReport/monthEnergyCost";
import monthEquipPara from "@/store/prd/productionReport/monthReport/monthEquipPara";
import monthMaterialCost from "@/store/prd/productionReport/monthReport/monthMaterialCost";
import monthPelletizingProductInfo from "@/store/prd/productionReport/monthReport/monthPelletizingProductInfo";
import monthPelletizingProductQuality from "@/store/prd/productionReport/monthReport/monthPelletizingProductQuality";
import monthSmeltingProductInfo from "@/store/prd/productionReport/monthReport/monthSmeltingProductInfo";
import monthSmeltingProductQuality from "@/store/prd/productionReport/monthReport/monthSmeltingProductQuality";
import monthPelletizingProductionQuality
    from "@/store/prd/productionReport/monthReport/monthPelletizingProductionQuality";
import monthPelletizingProductionQualityItem
    from "@/store/prd/productionReport/monthReport/monthPelletizingProductionQualityItem";
import monthSmeltingProductionQuality from "@/store/prd/productionReport/monthReport/monthSmeltingProductionQuality";
import monthSmeltingProductionQualityItem
    from "@/store/prd/productionReport/monthReport/monthSmeltingProductionQualityItem";
import dayPelletizingProductionQuality from "@/store/prd/productionReport/dayReport/dayPelletizingProductionQuality";
import dayPelletizingProductionQualityItem
    from "@/store/prd/productionReport/dayReport/dayPelletizingProductionQualityItem";
import daySmeltingProductionQuality from "@/store/prd/productionReport/dayReport/daySmeltingProductionQuality";
import daySmeltingProductionQualityItem from "@/store/prd/productionReport/dayReport/daySmeltingProductionQualityItem";

//quality
import qualityItem from "@/store/prd/qualityMgt/qualityItemConfig/qualityItem";
import qualityItemDetails from "@/store/prd/qualityMgt/qualityItemConfig/qualityItemDetails";
import selfTestPelletizing from "@/store/prd/qualityMgt/selfTest/selfTestPelletizing";
import selfTestPelletizingGri from "@/store/prd/qualityMgt/selfTest/selfTestPelletizingGri";
import selfTestPelletizingPel from "@/store/prd/qualityMgt/selfTest/selfTestPelletizingPel";
import selfTestPelletizingCal from "@/store/prd/qualityMgt/selfTest/selfTestPelletizingCal";
import qualityPlan from "@/store/prd/qualityMgt/pelletizing/qualityPlan";
import qualityData from "@/store/prd/qualityMgt/pelletizing/qualityData";
import qualityResult from "@/store/prd/qualityMgt/pelletizing/qualityResult";
import qualitySamplePlan from "@/store/prd/qualityMgt/pelletizing/qualitySamplePlan";
import slagMeltingPoint from "@/store/prd/qualityMgt/pelletizing/slagMeltingPoint";

//prd record
import furnaceTemperature from "@/store/prd/dailyReportMgt/furnaceTemperatrue";
import ceramicFilterPara from "@/store/prd/productionExecution/pelletizing/ceramicFilterPara";
import smeltingPreheatingKilnPara from "@/store/prd/productionExecution/smelting/smeltingPreheatingKilnPara";
import smeltingFurnaceMeasure from "@/store/prd/productionExecution/smelting/smeltingFurnaceMeasure";
import coolingWaterPara from "@/store/prd/productionExecution/smelting/coolingWaterPara";
import electrodePastePara from "@/store/prd/productionExecution/smelting/electrodePastePara";
import thickenerPumpPara from "@/store/prd/productionExecution/smelting/thickenerPumpPara";
import smeltingPreheatingKilnStop from "@/store/prd/productionExecution/smelting/smeltingPreheatingKilnStop";
import pressureDropWeightChange from "@/store/prd/productionExecution/smelting/pressureDropWeightChange";
import releasedElectrodePara from "@/store/prd/productionExecution/smelting/releasedElectrodePara";
import electrodeDischargePlan from "@/store/prd/productionExecution/smelting/electrodeDischargePlan";
import gasCabinetPara from "@/store/prd/productionExecution/smelting/gasCabinetPara";
import gasFlowPara from "@/store/prd/productionExecution/smelting/gasFlowPara";
import substationOperationPara from "@/store/prd/productionExecution/smelting/substationOperationPara";
import furnacePowerFailure from "@/store/prd/productionExecution/smelting/furnacePowerFailure";
import slagIronPara from "@/store/prd/productionExecution/smelting/slagIronPara";
import electrodeResistance from "@/store/prd/productionExecution/smelting/electrodeResistance";
import drillDepth from "@/store/prd/productionExecution/smelting/drillDepth";
import pelletFeeding from "@/store/prd/productionExecution/smelting/pelletFeeding";
import smeltingMaterialPercentRecord from "@/store/prd/productionExecution/smelting/smeltingMaterialPercentRecord";

//reportTemplate
import reportTemplate from "@/store/report/ReportTemplate";
import quartzSchedule from "@/store/quartz/QuartzSchedule";
import log from "@/store/adm/log";


import shiftHandOver from "@/store/prd/shiftHandOver/shiftHandOver";
import productionInform from "@/store/prd/productionInform/productionInform"


// em
import indexEmStores from "@/store/em/index-em-stores";
import indexEmAssistantStores from "@/store/emAssistant/index-emAssistant-stores";
// end em
// sith mes
import indexSithMesStores from "@/store/sithMes/index-sithMes-stores";
import indexSithMesIIStores from "@/store/sithMesII/index-sithMesII-stores";

//layouts
import indexLayoutsStores from "@/store/layouts/index-layouts-stores"

import mintalMesStores from "@/store/mintalMes/index-mintalMes-stores"

import partyBuilding from "@/store/party-building/moduleIndex-store-party-building"
import indexHolderStores from "@/store/holder/index-holder-stores";

Vue.use(Vuex);

const enableStrictStore = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        base,
        confirmationModal,
        entityModal,
        drawingDownload,
        api,
        uploadModal,
        auth,
        dimSearch,
        threadHistory,
        systemParameters,
        integrationMessage,
        integrationMessageConfig,
        userPreferences,
        userSetting,
        role,
        dataField,
        chart,

        //master
        report,
        reportGenerated,
        systemType,
        systemInstance,
        messageType,
        teamShift,
        location,
        equipment,
        material,
        energy,

        processOption,
        processMaterial,
        processEnergy,

        //inventory
        rawMaterial,
        adjust,
        outIn,
        formulaPlan,
        formulaPlanDetails,

        //quality
        qualityItem,
        qualityItemDetails,
        selfTestPelletizing,
        selfTestPelletizingGri,
        selfTestPelletizingPel,
        selfTestPelletizingCal,
        qualityPlan,
        qualitySamplePlan,
        qualityData,
        qualityResult,
        slagMeltingPoint,

        //prd plan
        downtimePlan,
        monthPlan,
        matRequireMonthPlan,
        shiftPlan,
        qualitySpecification,

        //prd result
        pelletizingEnergyCost,
        pelletizingEquipPara,
        pelletizingMaterialCost,
        pelletizingProductInfo,
        pelletizingProductionResult,
        pelletizingProductQuality,
        pelletizingProductionQuality,
        pelletizingProductionQualityItem,

        smeltingEnergyCost,
        smeltingEquipPara,
        smeltingMaterialCost,
        smeltingProductInfo,
        smeltingProductionResult,
        smeltingProductQuality,
        smeltingMaterialPercentRecord,
        smeltingProductionQuality,
        smeltingProductionQualityItem,

        //prd report
        dayEnergyCost,
        dayEquipPara,
        dayMaterialCost,
        dayPelletizingProductInfo,
        dayPelletizingProductQuality,
        daySmeltingProductInfo,
        daySmeltingProductQuality,
        monthEnergyCost,
        monthEquipPara,
        monthMaterialCost,
        monthPelletizingProductInfo,
        monthPelletizingProductQuality,
        monthSmeltingProductInfo,
        monthSmeltingProductQuality,
        monthPelletizingProductionQuality,
        monthPelletizingProductionQualityItem,
        monthSmeltingProductionQuality,
        monthSmeltingProductionQualityItem,
        dayPelletizingProductionQuality,
        dayPelletizingProductionQualityItem,
        daySmeltingProductionQuality,
        daySmeltingProductionQualityItem,

        //prd record
        furnaceTemperature,
        ceramicFilterPara,
        smeltingPreheatingKilnPara,
        smeltingFurnaceMeasure,
        coolingWaterPara,
        electrodePastePara,
        thickenerPumpPara,
        smeltingPreheatingKilnStop,
        pressureDropWeightChange,
        releasedElectrodePara,
        electrodeDischargePlan,
        gasCabinetPara,
        gasFlowPara,
        substationOperationPara,
        furnacePowerFailure,
        slagIronPara,
        electrodeResistance,
        drillDepth,
        pelletFeeding,
        shiftHandOver,
        productionInform,
        //report
        reportTemplate,
        log,
        quartzSchedule,

        //em
        ...indexEmStores,
        ...indexEmAssistantStores,
        //sithMes
        ...indexSithMesStores,
        ...indexSithMesIIStores,
        //layouts
        ...indexLayoutsStores,
        //mintal
        ...mintalMesStores,
        ...partyBuilding,

        ...indexHolderStores,
    },
    strict: enableStrictStore,
});
